// libs
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'o2web-react-core';

// Component
import Card from '../../../cards/card/Card';
import CardSlider from '../../../cards/cardSlider/CardSlider';
import LinedTitle from '../../../tools/linedTitle/LinedTitle';

// Styles
import './styles.scss';

// Props and Context
const propTypes = {
  cards: PropTypes.array.isRequired,
  contentType: PropTypes.oneOf(['activity', 'resource', 'artwork']).isRequired,
};
const defaultProps = {};
const contextType = {
  t: PropTypes.func,
};

function Favorites(props, { t }) {
  const {
    cards,
    contentType,
  } = props;
  return (
    <section className="favorites section section--grey">
      <div className="section__wrapper">
        <LinedTitle
          title={t('pages.landing.favorites')}
        />
        <CardSlider>
          {cards.map(card =>
            <div className="grid__item" key={`card-${card.cardType}-${card.slug}`}>
              <Card
                cardType={card.cardType}
                slug={card.slug}
                {...card}
              />
            </div>,
          )}
        </CardSlider>
        <div className="favorites__link">
          <NavLink
            to={`/${t('routes.search')}?filterCategory=${contentType}`}
            className="button button--fill"
          >
            {t(`pages.landing.seeAll.${contentType}`)}
          </NavLink>
        </div>
      </div>
    </section>
  );
}

Favorites.propTypes = propTypes;
Favorites.defaultProps = defaultProps;
Favorites.contextTypes = contextType;

export default Favorites;



// WEBPACK FOOTER //
// ./src/app/components/pages/landing/favorites/Favorites.js